import { render, staticRenderFns } from "./CoreGroupbuyListV2.vue?vue&type=template&id=2c5b2c44&"
import script from "./CoreGroupbuyListV2.vue?vue&type=script&lang=js&"
export * from "./CoreGroupbuyListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports